module.exports = __webpack_public_path__ + "assets/images/affirm.5afd541f2803635d8f85651c7163f089.svg";